interface IScrollBottom {
  offsetHeight: number;
  scrollHeight: number;
  scrollTop: number;
}

export const scrollBottom = ({ offsetHeight, scrollHeight, scrollTop }: IScrollBottom): number => {
  return Math.round(scrollHeight - scrollTop - offsetHeight + 1300);
};
